

import { useEffect, useState, useMemo, useCallback } from "react";
import { Link } from "react-router-dom";
import { FaTimes, FaArrowRight } from "react-icons/fa";
import "../styles/WelcomeAd.css";

// ⭐ EDIT THIS — your advertising settings
const AD = {
  active: true,
  image: "/images/banner/usha_banner1.png",         // your ad image
  alt: "Special Offer at USHA Resort",
  link: "/contact",
  autoCloseSeconds: 10,   // 0 = never auto-close
};

// 👇 Sparkle stars — reusable layer (used on background AND image)
const Sparkles = ({ count = 26 }) => {
  const sparkles = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        left: Math.random() * 100,
        top: Math.random() * 100,
        size: 8 + Math.random() * 16,          // 👈 bigger than before
        delay: Math.random() * 3,
        duration: 1.6 + Math.random() * 2,
        gold: Math.random() > 0.45,
      })),
    [count]
  );

  return (
    <div className="ad-sparkles" aria-hidden="true">
      {sparkles.map((s) => (
        <span
          key={s.id}
          className={`sparkle ${s.gold ? "gold" : "white"}`}
          style={{
            left: `${s.left}%`,
            top: `${s.top}%`,
            width: s.size,
            height: s.size,
            animationDelay: `${s.delay}s`,
            animationDuration: `${s.duration}s`,
          }}
        />
      ))}
    </div>
  );
};

const WelcomeAd = () => {
  const [open, setOpen] = useState(false);
  const [countdown, setCountdown] = useState(AD.autoCloseSeconds);

  const closeAd = useCallback(() => setOpen(false), []);

  // 👇 Show on EVERY page load / refresh — no session memory anymore
  useEffect(() => {
    if (!AD.active) return;
    const t = setTimeout(() => setOpen(true), 500);
    return () => clearTimeout(t);
  }, []);

  // While open: lock scroll, Esc closes, countdown runs
  useEffect(() => {
    if (!open) return;

    document.body.style.overflow = "hidden";

    const onKey = (e) => { if (e.key === "Escape") closeAd(); };
    window.addEventListener("keydown", onKey);

    let timer = null;
    if (AD.autoCloseSeconds > 0) {
      timer = setInterval(() => setCountdown((c) => c - 1), 1000);
    }

    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
      if (timer) clearInterval(timer);
    };
  }, [open, closeAd]);

  useEffect(() => {
    if (open && AD.autoCloseSeconds > 0 && countdown <= 0) closeAd();
  }, [countdown, open, closeAd]);

  if (!open) return null;

  return (
    <div className="ad-overlay" role="dialog" aria-modal="true" aria-label="Special offer">
      {/* ✨ NEW: sparkles across the FULL dark background (around the box) */}
      <Sparkles count={30} />

      <div className="ad-box">
        <button className="ad-close" onClick={closeAd} aria-label="Close advertisement">
          <FaTimes />
        </button>

        {/* ✨ sparkles + shine on the image too */}
        <Sparkles count={20} />
        <div className="ad-shine" aria-hidden="true" />

        <span className="ad-badge">✨ Limited Time Offer</span>

        <Link to={AD.link} onClick={closeAd} className="ad-img-link">
          <img className="ad-img" src={AD.image} alt={AD.alt} />
        </Link>

        <div className="ad-actions">
          <Link to={AD.link} onClick={closeAd} className="btn btn-gold">
            Grab This Offer <FaArrowRight />
          </Link>
          <button className="ad-skip" onClick={closeAd}>
            Skip Ad {AD.autoCloseSeconds > 0 && `(${Math.max(countdown, 0)}s)`}
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeAd;
